/**
 * Cosmos-Forge Developer Environment (CFDE) only: lets the agent chat run without Google sign-in.
 * Requires NEXT_PUBLIC_CFDE_DEV_AUTH=1 and is never active in production builds.
 */
export const CFDE_DEV_AUTH = process.env.NODE_ENV !== 'production' && process.env.NEXT_PUBLIC_CFDE_DEV_AUTH === '1';

/** Owner recorded on agent chats created without sign-in. */
export const CFDE_DEV_OWNER = 'developer@forge.local';
